import React from "react";

export const ErrorBanner = ({ message }: { message: string }) => <div className="soil-sight-validation-error-banner">{message}</div>;
